import IdentityFormModalReducer from "@common/redux/reducers/IdentityFormModalReducer";
import BaseAction from "./BaseAction";

class IdentityFormModalAction extends BaseAction {
  onClose = () => {};
  onSubmit = async () => {};
  onExists = async () => {};

  open = async (onOpen, onSubmit, data) => {
    await onOpen();
    this.dispatch({ open: true, ...data });
    this.onSubmit = onSubmit;
  };

  onType = (searchQuery) => {
    this.dispatch({ searchQuery: searchQuery });
  };

  setLoadingIdentityOptions = async (value) => {
    this.dispatch({ loadingIdentityOptions: value });
  };
}

const action = new IdentityFormModalAction(IdentityFormModalReducer);

export default action;
